import { t } from 'i18next'

import {
  formatSettledDay,
  MetricAlertIcon,
  type MetricAlertProps
} from '../MetricAlertIcon'

export function LostIsRankAlertIcon({
  value,
  settledDay,
  loading = false
}: MetricAlertProps) {
  if (loading) return null

  if (value == null) {
    const date = formatSettledDay(settledDay)

    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.lostIsRankAlert')}
        text={
          date
            ? t('rm:alerts.impressionShareFamilyConsolidatedUntil', { date })
            : t('rm:alerts.lostIsRankUnavailable')
        }
        variant="warning"
        testId="lost-is-rank-icon"
      />
    )
  }

  if (Number(value) === 0) {
    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.lostIsRankAlert')}
        text={t('rm:alerts.lostIsRankNoLoss')}
        variant="informational"
        testId="lost-is-rank-icon"
      />
    )
  }

  return null
}
